import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {
  IPortfolioResultRequest,
  IPortfolioResultResponse
} from "@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model";
import {IrbEditorPortfolioResultService} from "@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.service";
import {IrbAppEvents} from "@irb/app.events";
import {AppService} from "@irb/app.service";
import {UtilityService} from "@irb-common/services/utility.service";
import {Router} from "@angular/router";

@Component({ standalone: false,
  selector: 'irb-dialog-pr-manual-adjustment',
  templateUrl: './dialog-pr-manual-adjustment.component.html',
  styleUrls: ['./dialog-pr-manual-adjustment.component.scss']
})
export class DialogPrManualAdjustmentComponent implements OnInit {
  rebalanceName: string = '';
  constructor(
    public dialogRef: MatDialogRef<DialogPrManualAdjustmentComponent>,
    public prs: IrbEditorPortfolioResultService,
    public as: AppService,
    public util: UtilityService,
    public readonly router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    const currentDateTime = new Date().getTime();
    const currentDateStr = this.util.formatEasternDate(currentDateTime, '/');
    if (!this.data) { this.data = {}; }
    this.rebalanceName = this.data.portfolioName + ' - Manual Adj - ' + currentDateStr;
  }
  close() {
    this.dialogRef.close();
  }

  continue() {
    let payload: any = {
      method: "resubmitTrades",
      newRebalanceName: this.rebalanceName,
      newTradeExplanation: this.data.tradeExplanation,
      pfRestricnDTOList: [], // sa ???????
      portfolioId: this.data.portfolioId,
      rebalId: this.data.rebalId,
      rebalType: 'Manual adjustment'
    };
    this.prs.getPortfolioResult(payload).subscribe((resp: IPortfolioResultResponse) => {
      const successMessage = resp.resMessage || '';
      const errorMessage = resp.errMessage || ''
      this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
        severity: successMessage ? 'success' : 'error',
        summary: successMessage ? 'Success' : (errorMessage || 'An error occurred processing your request.'),
        detail: successMessage || ''
      });
      this.close();
      this.navigateToResultSummary(resp.rebalId);
    });

  }

  navigateToResultSummary(rebalanceResultId: any) {
    this.router.navigateByUrl("/rebalancing/rebalance-results", { skipLocationChange: false }).
    then(() => this.router.navigate(["/rebalancing/result-summary/", rebalanceResultId]));
  }
}
